import script from "./memorialedit.vue?vue&type=script&setup=true&lang=ts"
export * from "./memorialedit.vue?vue&type=script&setup=true&lang=ts"

import "./memorialedit.vue?vue&type=style&index=0&id=4b12cb09&lang=css"
import "./memorialedit.vue?vue&type=style&index=1&id=4b12cb09&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b12cb09"]])

export default __exports__